import { css, StyleDeclaration, StyleSheet } from 'aphrodite';
import { aceGray } from '../../../../styles/colors';

const s = StyleSheet.create({
	icon: {
		color: aceGray,
	},
});

export function NoteAddIcon({
	styles = [],
	...props
}: Exclude<React.SVGProps<SVGSVGElement>, 'className'> & { styles?: StyleDeclaration[] }) {
	return (
		<svg width={18} height={18} viewBox='0 0 18 18' className={css(s.icon, ...styles)} {...props}>
			<path
				fill='currentColor'
				d='M11 14.586V12c0-.552.449-1 1-1h2.586L11 14.586ZM2 16V2h14v7h-4c-1.654 0-3 1.346-3 3v4H2ZM16 0H2C.897 0 0 .898 0 2v14c0 1.103.897 2 2 2h7c.819 0 1.835-.42 2.414-1L17 11.414c.58-.58 1-1.595 1-2.414V2c0-1.102-.897-2-2-2Z'
				fillRule='evenodd'
			/>
			<path fill='none' stroke='currentColor' strokeWidth='2' strokeMiterlimit='10' d='M6.778 3.457v7M3.278 6.957h7' />
		</svg>
	);
}
